module.exports = __webpack_public_path__ + "assets/img/1.c187eb7c.png";